// extracted by mini-css-extract-plugin
export var alertIcon = "_vc-0";